import styled from 'styled-components';
const ResultListStyled = styled.div`
  flex-grow: 1;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  .hover {
    cursor: pointer;
    position: relative;
    display: block;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .table-wrapper {
    flex: 1;
  }
  .hover:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
  }
  .export-wrapper {
    margin: 16px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 80px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
`;
export default ResultListStyled;
